<template>
  <div class="generic-price-tile" :class="{ 'is-default': !isCustom }">
    <div class="wrapp-content">
      <span class="value sku">{{price.product_sku}}</span>
      <span class="value name">{{price.item_text}}</span>
      <span class="value amount">{{amount}}</span>
      <span class="value price">{{price.price | price($store)}}</span>
    </div>
    <div class="block-remove">
      <button class="btn btn-none btn-remove-icon" type="button" @click.prevent="removePrice">
        <div class="wrapp-icon">
          <svg class="o-icon" v-show="!isCustom"><use xlink:href="#lock"></use></svg>
          <svg class="o-icon" v-show="isCustom"><use xlink:href="#trash"></use></svg>
        </div>
      </button>
    </div>
  </div>
</template>

<script>
import { price as filterPrice } from '@/filters'

export default {
  name: 'GenericPriceTile',
  props: {
    price: {
      type: Object,
      required: true
    },
    identifier: {
      type: String,
      required: true
    }
  },
  computed: {
    isCustom () {
      return this.price.custom && this.price.manual
    },
    amount () {
      if (this.price && this.price.applied_discount && 'type' in this.price.applied_discount) {
        let type = this.price.applied_discount.type
        switch (type) {
          case 'percentage':
            return `${this.price.applied_discount.percentage} %`
          case 'amount':
            return filterPrice(this.price.applied_discount.amount, this.$store)
          case 'fixed_price':
            return filterPrice(this.price.applied_discount.amount, this.$store)
        }
      }
    }
  },
  methods: {
    removePrice () {
      return this.$emit('remove-price', { price: this.price, identifier: this.identifier })
    }
  }
}
</script>
